// @flow
import _ from 'lodash';
import I18n from '../i18n/I18n';

/**
 * TODO: localize
 */
export default class CountriesList {

  static getCountriesList() {
    return [
      {
        id: '4',
        alpha3: 'AFG',
        iso: 'AF',
        name: I18n.getCountry('AF'),
      },
      {
        id: '710',
        alpha3: 'ZAF',
        iso: 'ZA',
        name: I18n.getCountry('ZA'),
      },
      {
        id: '248',
        alpha3: 'ALA',
        iso: 'AX',
        name: I18n.getCountry('AX'),
      },
      {
        id: '8',
        alpha3: 'ALB',
        iso: 'AL',
        name: I18n.getCountry('AL'),
      },
      {
        id: '12',
        alpha3: 'DZA',
        iso: 'DZ',
        name: I18n.getCountry('DZ'),
      },
      {
        id: '276',
        alpha3: 'DEU',
        iso: 'DE',
        name: I18n.getCountry('DE'),
      },
      {
        id: '20',
        alpha3: 'AND',
        iso: 'AD',
        name: I18n.getCountry('AD'),
      },
      {
        id: '24',
        alpha3: 'AGO',
        iso: 'AO',
        name: I18n.getCountry('AO'),
      },
      {
        id: '660',
        alpha3: 'AIA',
        iso: 'AI',
        name: I18n.getCountry('AI'),
      },
      {
        id: '10',
        alpha3: 'ATA',
        iso: 'AQ',
        name: I18n.getCountry('AQ'),
      },
      {
        id: '28',
        alpha3: 'ATG',
        iso: 'AG',
        name: I18n.getCountry('AG'),
      },
      {
        id: '682',
        alpha3: 'SAU',
        iso: 'SA',
        name: I18n.getCountry('SA'),
      },
      {
        id: '32',
        alpha3: 'ARG',
        iso: 'AR',
        name: I18n.getCountry('AR'),
      },
      {
        id: '51',
        alpha3: 'ARM',
        iso: 'AM',
        name: I18n.getCountry('AM'),
      },
      {
        id: '533',
        alpha3: 'ABW',
        iso: 'AW',
        name: I18n.getCountry('AW'),
      },
      {
        id: '36',
        alpha3: 'AUS',
        iso: 'AU',
        name: I18n.getCountry('AU'),
      },
      {
        id: '40',
        alpha3: 'AUT',
        iso: 'AT',
        name: I18n.getCountry('AT'),
      },
      {
        id: '31',
        alpha3: 'AZE',
        iso: 'AZ',
        name: I18n.getCountry('AZ'),
      },
      {
        id: '44',
        alpha3: 'BHS',
        iso: 'BS',
        name: I18n.getCountry('BS'),
      },
      {
        id: '48',
        alpha3: 'BHR',
        iso: 'BH',
        name: I18n.getCountry('BH'),
      },
      {
        id: '50',
        alpha3: 'BGD',
        iso: 'BD',
        name: I18n.getCountry('BD'),
      },
      {
        id: '52',
        alpha3: 'BRB',
        iso: 'BB',
        name: I18n.getCountry('BB'),
      },
      {
        id: '112',
        alpha3: 'BLR',
        iso: 'BY',
        name: I18n.getCountry('BY'),
      },
      {
        id: '56',
        alpha3: 'BEL',
        iso: 'BE',
        name: I18n.getCountry('BE'),
      },
      {
        id: '84',
        alpha3: 'BLZ',
        iso: 'BZ',
        name: I18n.getCountry('BZ'),
      },
      {
        id: '204',
        alpha3: 'BEN',
        iso: 'BJ',
        name: I18n.getCountry('BJ'),
      },
      {
        id: '60',
        alpha3: 'BMU',
        iso: 'BM',
        name: I18n.getCountry('BM'),
      },
      {
        id: '64',
        alpha3: 'BTN',
        iso: 'BT',
        name: I18n.getCountry('BT'),
      },
      {
        id: '68',
        alpha3: 'BOL',
        iso: 'BO',
        name: I18n.getCountry('BO'),
      },
      {
        id: '535',
        alpha3: 'BES',
        iso: 'BQ',
        name: I18n.getCountry('BQ'),
      },
      {
        id: '70',
        alpha3: 'BIH',
        iso: 'BA',
        name: I18n.getCountry('BA'),
      },
      {
        id: '72',
        alpha3: 'BWA',
        iso: 'BW',
        name: I18n.getCountry('BW'),
      },
      {
        id: '74',
        alpha3: 'BVT',
        iso: 'BV',
        name: I18n.getCountry('BV'),
      },
      {
        id: '76',
        alpha3: 'BRA',
        iso: 'BR',
        name: I18n.getCountry('BR'),
      },
      {
        id: '96',
        alpha3: 'BRN',
        iso: 'BN',
        name: I18n.getCountry('BN'),
      },
      {
        id: '100',
        alpha3: 'BGR',
        iso: 'BG',
        name: I18n.getCountry('BG'),
      },
      {
        id: '854',
        alpha3: 'BFA',
        iso: 'BF',
        name: I18n.getCountry('BF'),
      },
      {
        id: '108',
        alpha3: 'BDI',
        iso: 'BI',
        name: I18n.getCountry('BI'),
      },
      {
        id: '136',
        alpha3: 'CYM',
        iso: 'KY',
        name: I18n.getCountry('KY'),
      },
      {
        id: '116',
        alpha3: 'KHM',
        iso: 'KH',
        name: I18n.getCountry('KH'),
      },
      {
        id: '120',
        alpha3: 'CMR',
        iso: 'CM',
        name: I18n.getCountry('CM'),
      },
      {
        id: '124',
        alpha3: 'CAN',
        iso: 'CA',
        name: I18n.getCountry('CA'),
      },
      {
        id: '132',
        alpha3: 'CPV',
        iso: 'CV',
        name: I18n.getCountry('CV'),
      },
      {
        id: '140',
        alpha3: 'CAF',
        iso: 'CF',
        name: I18n.getCountry('CF'),
      },
      {
        id: '152',
        alpha3: 'CHL',
        iso: 'CL',
        name: I18n.getCountry('CL'),
      },
      {
        id: '156',
        alpha3: 'CHN',
        iso: 'CN',
        name: I18n.getCountry('CN'),
      },
      {
        id: '162',
        alpha3: 'CXR',
        iso: 'CX',
        name: I18n.getCountry('CX'),
      },
      {
        id: '196',
        alpha3: 'CYP',
        iso: 'CY',
        name: I18n.getCountry('CY'),
      },
      {
        id: '166',
        alpha3: 'CCK',
        iso: 'CC',
        name: I18n.getCountry('CC'),
      },
      {
        id: '170',
        alpha3: 'COL',
        iso: 'CO',
        name: I18n.getCountry('CO'),
      },
      {
        id: '174',
        alpha3: 'COM',
        iso: 'KM',
        name: I18n.getCountry('KM'),
      },
      {
        id: '178',
        alpha3: 'COG',
        iso: 'CG',
        name: I18n.getCountry('CG'),
      },
      {
        id: '180',
        alpha3: 'COD',
        iso: 'CD',
        name: I18n.getCountry('CD'),
      },
      {
        id: '184',
        alpha3: 'COK',
        iso: 'CK',
        name: I18n.getCountry('CK'),
      },
      {
        id: '410',
        alpha3: 'KOR',
        iso: 'KR',
        name: I18n.getCountry('KR'),
      },
      {
        id: '408',
        alpha3: 'PRK',
        iso: 'KP',
        name: I18n.getCountry('KP'),
      },
      {
        id: '188',
        alpha3: 'CRI',
        iso: 'CR',
        name: I18n.getCountry('CR'),
      },
      {
        id: '384',
        alpha3: 'CIV',
        iso: 'CI',
        name: I18n.getCountry('CI'),
      },
      {
        id: '191',
        alpha3: 'HRV',
        iso: 'HR',
        name: I18n.getCountry('HR'),
      },
      {
        id: '192',
        alpha3: 'CUB',
        iso: 'CU',
        name: I18n.getCountry('CU'),
      },
      {
        id: '531',
        alpha3: 'CUW',
        iso: 'CW',
        name: I18n.getCountry('CW'),
      },
      {
        id: '208',
        alpha3: 'DNK',
        iso: 'DK',
        name: I18n.getCountry('DK'),
      },
      {
        id: '262',
        alpha3: 'DJI',
        iso: 'DJ',
        name: I18n.getCountry('DJ'),
      },
      {
        id: '214',
        alpha3: 'DOM',
        iso: 'DO',
        name: I18n.getCountry('DO'),
      },
      {
        id: '212',
        alpha3: 'DMA',
        iso: 'DM',
        name: I18n.getCountry('DM'),
      },
      {
        id: '818',
        alpha3: 'EGY',
        iso: 'EG',
        name: I18n.getCountry('EG'),
      },
      {
        id: '222',
        alpha3: 'SLV',
        iso: 'SV',
        name: I18n.getCountry('SV'),
      },
      {
        id: '784',
        alpha3: 'ARE',
        iso: 'AE',
        name: I18n.getCountry('AE'),
      },
      {
        id: '218',
        alpha3: 'ECU',
        iso: 'EC',
        name: I18n.getCountry('EC'),
      },
      {
        id: '232',
        alpha3: 'ERI',
        iso: 'ER',
        name: I18n.getCountry('ER'),
      },
      {
        id: '724',
        alpha3: 'ESP',
        iso: 'ES',
        name: I18n.getCountry('ES'),
      },
      {
        id: '233',
        alpha3: 'EST',
        iso: 'EE',
        name: I18n.getCountry('EE'),
      },
      {
        id: '840',
        alpha3: 'USA',
        iso: 'US',
        name: I18n.getCountry('US'),
      },
      {
        id: '231',
        alpha3: 'ETH',
        iso: 'ET',
        name: I18n.getCountry('ET'),
      },
      {
        id: '238',
        alpha3: 'FLK',
        iso: 'FK',
        name: I18n.getCountry('FK'),
      },
      {
        id: '234',
        alpha3: 'FRO',
        iso: 'FO',
        name: I18n.getCountry('FO'),
      },
      {
        id: '242',
        alpha3: 'FJI',
        iso: 'FJ',
        name: I18n.getCountry('FJ'),
      },
      {
        id: '246',
        alpha3: 'FIN',
        iso: 'FI',
        name: I18n.getCountry('FI'),
      },
      {
        id: '250',
        alpha3: 'FRA',
        iso: 'FR',
        name: I18n.getCountry('FR'),
      },
      {
        id: '266',
        alpha3: 'GAB',
        iso: 'GA',
        name: I18n.getCountry('GA'),
      },
      {
        id: '270',
        alpha3: 'GMB',
        iso: 'GM',
        name: I18n.getCountry('GM'),
      },
      {
        id: '268',
        alpha3: 'GEO',
        iso: 'GE',
        name: I18n.getCountry('GE'),
      },
      {
        id: '239',
        alpha3: 'SGS',
        iso: 'GS',
        name: I18n.getCountry('GS'),
      },
      {
        id: '288',
        alpha3: 'GHA',
        iso: 'GH',
        name: I18n.getCountry('GH'),
      },
      {
        id: '292',
        alpha3: 'GIB',
        iso: 'GI',
        name: I18n.getCountry('GI'),
      },
      {
        id: '300',
        alpha3: 'GRC',
        iso: 'GR',
        name: I18n.getCountry('GR'),
      },
      {
        id: '308',
        alpha3: 'GRD',
        iso: 'GD',
        name: I18n.getCountry('GD'),
      },
      {
        id: '304',
        alpha3: 'GRL',
        iso: 'GL',
        name: I18n.getCountry('GL'),
      },
      {
        id: '312',
        alpha3: 'GLP',
        iso: 'GP',
        name: I18n.getCountry('GP'),
      },
      {
        id: '316',
        alpha3: 'GUM',
        iso: 'GU',
        name: I18n.getCountry('GU'),
      },
      {
        id: '320',
        alpha3: 'GTM',
        iso: 'GT',
        name: I18n.getCountry('GT'),
      },
      {
        id: '831',
        alpha3: 'GGY',
        iso: 'GG',
        name: I18n.getCountry('GG'),
      },
      {
        id: '324',
        alpha3: 'GIN',
        iso: 'GN',
        name: I18n.getCountry('GN'),
      },
      {
        id: '624',
        alpha3: 'GNB',
        iso: 'GW',
        name: I18n.getCountry('GW'),
      },
      {
        id: '226',
        alpha3: 'GNQ',
        iso: 'GQ',
        name: I18n.getCountry('GQ'),
      },
      {
        id: '328',
        alpha3: 'GUY',
        iso: 'GY',
        name: I18n.getCountry('GY'),
      },
      {
        id: '254',
        alpha3: 'GUF',
        iso: 'GF',
        name: I18n.getCountry('GF'),
      },
      {
        id: '332',
        alpha3: 'HTI',
        iso: 'HT',
        name: I18n.getCountry('HT'),
      },
      {
        id: '334',
        alpha3: 'HMD',
        iso: 'HM',
        name: I18n.getCountry('HM'),
      },
      {
        id: '340',
        alpha3: 'HND',
        iso: 'HN',
        name: I18n.getCountry('HN'),
      },
      {
        id: '344',
        alpha3: 'HKG',
        iso: 'HK',
        name: I18n.getCountry('HK'),
      },
      {
        id: '348',
        alpha3: 'HUN',
        iso: 'HU',
        name: I18n.getCountry('HU'),
      },
      {
        id: '833',
        alpha3: 'IMN',
        iso: 'IM',
        name: I18n.getCountry('IM'),
      },
      {
        id: '581',
        alpha3: 'UMI',
        iso: 'UM',
        name: I18n.getCountry('UM'),
      },
      {
        id: '92',
        alpha3: 'VGB',
        iso: 'VG',
        name: I18n.getCountry('VG'),
      },
      {
        id: '850',
        alpha3: 'VIR',
        iso: 'VI',
        name: I18n.getCountry('VI'),
      },
      {
        id: '356',
        alpha3: 'IND',
        iso: 'IN',
        name: I18n.getCountry('IN'),
      },
      {
        id: '360',
        alpha3: 'IDN',
        iso: 'ID',
        name: I18n.getCountry('ID'),
      },
      {
        id: '364',
        alpha3: 'IRN',
        iso: 'IR',
        name: I18n.getCountry('IR'),
      },
      {
        id: '368',
        alpha3: 'IRQ',
        iso: 'IQ',
        name: I18n.getCountry('IQ'),
      },
      {
        id: '372',
        alpha3: 'IRL',
        iso: 'IE',
        name: I18n.getCountry('IE'),
      },
      {
        id: '352',
        alpha3: 'ISL',
        iso: 'IS',
        name: I18n.getCountry('IS'),
      },
      {
        id: '376',
        alpha3: 'ISR',
        iso: 'IL',
        name: I18n.getCountry('IL'),
      },
      {
        id: '380',
        alpha3: 'ITA',
        iso: 'IT',
        name: I18n.getCountry('IT'),
      },
      {
        id: '388',
        alpha3: 'JAM',
        iso: 'JM',
        name: I18n.getCountry('JM'),
      },
      {
        id: '392',
        alpha3: 'JPN',
        iso: 'JP',
        name: I18n.getCountry('JP'),
      },
      {
        id: '832',
        alpha3: 'JEY',
        iso: 'JE',
        name: I18n.getCountry('JE'),
      },
      {
        id: '400',
        alpha3: 'JOR',
        iso: 'JO',
        name: I18n.getCountry('JO'),
      },
      {
        id: '398',
        alpha3: 'KAZ',
        iso: 'KZ',
        name: I18n.getCountry('KZ'),
      },
      {
        id: '404',
        alpha3: 'KEN',
        iso: 'KE',
        name: I18n.getCountry('KE'),
      },
      {
        id: '417',
        alpha3: 'KGZ',
        iso: 'KG',
        name: I18n.getCountry('KG'),
      },
      {
        id: '296',
        alpha3: 'KIR',
        iso: 'KI',
        name: I18n.getCountry('KI'),
      },
      {
        id: '414',
        alpha3: 'KWT',
        iso: 'KW',
        name: I18n.getCountry('KW'),
      },
      {
        id: '418',
        alpha3: 'LAO',
        iso: 'LA',
        name: I18n.getCountry('LA'),
      },
      {
        id: '426',
        alpha3: 'LSO',
        iso: 'LS',
        name: I18n.getCountry('LS'),
      },
      {
        id: '428',
        alpha3: 'LVA',
        iso: 'LV',
        name: I18n.getCountry('LV'),
      },
      {
        id: '422',
        alpha3: 'LBN',
        iso: 'LB',
        name: I18n.getCountry('LB'),
      },
      {
        id: '430',
        alpha3: 'LBR',
        iso: 'LR',
        name: I18n.getCountry('LR'),
      },
      {
        id: '434',
        alpha3: 'LBY',
        iso: 'LY',
        name: I18n.getCountry('LY'),
      },
      {
        id: '438',
        alpha3: 'LIE',
        iso: 'LI',
        name: I18n.getCountry('LI'),
      },
      {
        id: '440',
        alpha3: 'LTU',
        iso: 'LT',
        name: I18n.getCountry('LT'),
      },
      {
        id: '442',
        alpha3: 'LUX',
        iso: 'LU',
        name: I18n.getCountry('LU'),
      },
      {
        id: '446',
        alpha3: 'MAC',
        iso: 'MO',
        name: I18n.getCountry('MO'),
      },
      {
        id: '807',
        alpha3: 'MKD',
        iso: 'MK',
        name: I18n.getCountry('MK'),
      },
      {
        id: '450',
        alpha3: 'MDG',
        iso: 'MG',
        name: I18n.getCountry('MG'),
      },
      {
        id: '458',
        alpha3: 'MYS',
        iso: 'MY',
        name: I18n.getCountry('MY'),
      },
      {
        id: '454',
        alpha3: 'MWI',
        iso: 'MW',
        name: I18n.getCountry('MW'),
      },
      {
        id: '462',
        alpha3: 'MDV',
        iso: 'MV',
        name: I18n.getCountry('MV'),
      },
      {
        id: '466',
        alpha3: 'MLI',
        iso: 'ML',
        name: I18n.getCountry('ML'),
      },
      {
        id: '470',
        alpha3: 'MLT',
        iso: 'MT',
        name: I18n.getCountry('MT'),
      },
      {
        id: '580',
        alpha3: 'MNP',
        iso: 'MP',
        name: I18n.getCountry('MP'),
      },
      {
        id: '504',
        alpha3: 'MAR',
        iso: 'MA',
        name: I18n.getCountry('MA'),
      },
      {
        id: '584',
        alpha3: 'MHL',
        iso: 'MH',
        name: I18n.getCountry('MH'),
      },
      {
        id: '474',
        alpha3: 'MTQ',
        iso: 'MQ',
        name: I18n.getCountry('MQ'),
      },
      {
        id: '480',
        alpha3: 'MUS',
        iso: 'MU',
        name: I18n.getCountry('MU'),
      },
      {
        id: '478',
        alpha3: 'MRT',
        iso: 'MR',
        name: I18n.getCountry('MR'),
      },
      {
        id: '175',
        alpha3: 'MYT',
        iso: 'YT',
        name: I18n.getCountry('YT'),
      },
      {
        id: '484',
        alpha3: 'MEX',
        iso: 'MX',
        name: I18n.getCountry('MX'),
      },
      {
        id: '583',
        alpha3: 'FSM',
        iso: 'FM',
        name: I18n.getCountry('FM'),
      },
      {
        id: '498',
        alpha3: 'MDA',
        iso: 'MD',
        name: I18n.getCountry('MD'),
      },
      {
        id: '492',
        alpha3: 'MCO',
        iso: 'MC',
        name: I18n.getCountry('MC'),
      },
      {
        id: '496',
        alpha3: 'MNG',
        iso: 'MN',
        name: I18n.getCountry('MN'),
      },
      {
        id: '499',
        alpha3: 'MNE',
        iso: 'ME',
        name: I18n.getCountry('ME'),
      },
      {
        id: '500',
        alpha3: 'MSR',
        iso: 'MS',
        name: I18n.getCountry('MS'),
      },
      {
        id: '508',
        alpha3: 'MOZ',
        iso: 'MZ',
        name: I18n.getCountry('MZ'),
      },
      {
        id: '104',
        alpha3: 'MMR',
        iso: 'MM',
        name: I18n.getCountry('MM'),
      },
      {
        id: '516',
        alpha3: 'NAM',
        iso: 'NA',
        name: I18n.getCountry('NA'),
      },
      {
        id: '520',
        alpha3: 'NRU',
        iso: 'NR',
        name: I18n.getCountry('NR'),
      },
      {
        id: '524',
        alpha3: 'NPL',
        iso: 'NP',
        name: I18n.getCountry('NP'),
      },
      {
        id: '558',
        alpha3: 'NIC',
        iso: 'NI',
        name: I18n.getCountry('NI'),
      },
      {
        id: '562',
        alpha3: 'NER',
        iso: 'NE',
        name: I18n.getCountry('NE'),
      },
      {
        id: '566',
        alpha3: 'NGA',
        iso: 'NG',
        name: I18n.getCountry('NG'),
      },
      {
        id: '570',
        alpha3: 'NIU',
        iso: 'NU',
        name: I18n.getCountry('NU'),
      },
      {
        id: '574',
        alpha3: 'NFK',
        iso: 'NF',
        name: I18n.getCountry('NF'),
      },
      {
        id: '578',
        alpha3: 'NOR',
        iso: 'NO',
        name: I18n.getCountry('NO'),
      },
      {
        id: '540',
        alpha3: 'NCL',
        iso: 'NC',
        name: I18n.getCountry('NC'),
      },
      {
        id: '554',
        alpha3: 'NZL',
        iso: 'NZ',
        name: I18n.getCountry('NZ'),
      },
      {
        id: '86',
        alpha3: 'IOT',
        iso: 'IO',
        name: I18n.getCountry('IO'),
      },
      {
        id: '512',
        alpha3: 'OMN',
        iso: 'OM',
        name: I18n.getCountry('OM'),
      },
      {
        id: '800',
        alpha3: 'UGA',
        iso: 'UG',
        name: I18n.getCountry('UG'),
      },
      {
        id: '860',
        alpha3: 'UZB',
        iso: 'UZ',
        name: I18n.getCountry('UZ'),
      },
      {
        id: '586',
        alpha3: 'PAK',
        iso: 'PK',
        name: I18n.getCountry('PK'),
      },
      {
        id: '585',
        alpha3: 'PLW',
        iso: 'PW',
        name: I18n.getCountry('PW'),
      },
      {
        id: '275',
        alpha3: 'PSE',
        iso: 'PS',
        name: I18n.getCountry('PS'),
      },
      {
        id: '591',
        alpha3: 'PAN',
        iso: 'PA',
        name: I18n.getCountry('PA'),
      },
      {
        id: '598',
        alpha3: 'PNG',
        iso: 'PG',
        name: I18n.getCountry('PG'),
      },
      {
        id: '600',
        alpha3: 'PRY',
        iso: 'PY',
        name: I18n.getCountry('PY'),
      },
      {
        id: '528',
        alpha3: 'NLD',
        iso: 'NL',
        name: I18n.getCountry('NL'),
      },
      {
        id: '604',
        alpha3: 'PER',
        iso: 'PE',
        name: I18n.getCountry('PE'),
      },
      {
        id: '608',
        alpha3: 'PHL',
        iso: 'PH',
        name: I18n.getCountry('PH'),
      },
      {
        id: '612',
        alpha3: 'PCN',
        iso: 'PN',
        name: I18n.getCountry('PN'),
      },
      {
        id: '616',
        alpha3: 'POL',
        iso: 'PL',
        name: I18n.getCountry('PL'),
      },
      {
        id: '258',
        alpha3: 'PYF',
        iso: 'PF',
        name: I18n.getCountry('PF'),
      },
      {
        id: '630',
        alpha3: 'PRI',
        iso: 'PR',
        name: I18n.getCountry('PR'),
      },
      {
        id: '620',
        alpha3: 'PRT',
        iso: 'PT',
        name: I18n.getCountry('PT'),
      },
      {
        id: '634',
        alpha3: 'QAT',
        iso: 'QA',
        name: I18n.getCountry('QA'),
      },
      {
        id: '638',
        alpha3: 'REU',
        iso: 'RE',
        name: I18n.getCountry('RE'),
      },
      {
        id: '642',
        alpha3: 'ROU',
        iso: 'RO',
        name: I18n.getCountry('RO'),
      },
      {
        id: '826',
        alpha3: 'GBR',
        iso: 'GB',
        name: I18n.getCountry('GB'),
      },
      {
        id: '643',
        alpha3: 'RUS',
        iso: 'RU',
        name: I18n.getCountry('RU'),
      },
      {
        id: '646',
        alpha3: 'RWA',
        iso: 'RW',
        name: I18n.getCountry('RW'),
      },
      {
        id: '732',
        alpha3: 'ESH',
        iso: 'EH',
        name: I18n.getCountry('EH'),
      },
      {
        id: '652',
        alpha3: 'BLM',
        iso: 'BL',
        name: I18n.getCountry('BL'),
      },
      {
        id: '659',
        alpha3: 'KNA',
        iso: 'KN',
        name: I18n.getCountry('KN'),
      },
      {
        id: '674',
        alpha3: 'SMR',
        iso: 'SM',
        name: I18n.getCountry('SM'),
      },
      {
        id: '663',
        alpha3: 'MAF',
        iso: 'MF',
        name: I18n.getCountry('MF'),
      },
      {
        id: '534',
        alpha3: 'SXM',
        iso: 'SX',
        name: I18n.getCountry('SX'),
      },
      {
        id: '666',
        alpha3: 'SPM',
        iso: 'PM',
        name: I18n.getCountry('PM'),
      },
      {
        id: '336',
        alpha3: 'VAT',
        iso: 'VA',
        name: I18n.getCountry('VA'),
      },
      {
        id: '670',
        alpha3: 'VCT',
        iso: 'VC',
        name: I18n.getCountry('VC'),
      },
      {
        id: '654',
        alpha3: 'SHN',
        iso: 'SH',
        name: I18n.getCountry('SH'),
      },
      {
        id: '662',
        alpha3: 'LCA',
        iso: 'LC',
        name: I18n.getCountry('LC'),
      },
      {
        id: '90',
        alpha3: 'SLB',
        iso: 'SB',
        name: I18n.getCountry('SB'),
      },
      {
        id: '882',
        alpha3: 'WSM',
        iso: 'WS',
        name: I18n.getCountry('WS'),
      },
      {
        id: '16',
        alpha3: 'ASM',
        iso: 'AS',
        name: I18n.getCountry('AS'),
      },
      {
        id: '678',
        alpha3: 'STP',
        iso: 'ST',
        name: I18n.getCountry('ST'),
      },
      {
        id: '686',
        alpha3: 'SEN',
        iso: 'SN',
        name: I18n.getCountry('SN'),
      },
      {
        id: '688',
        alpha3: 'SRB',
        iso: 'RS',
        name: I18n.getCountry('RS'),
      },
      {
        id: '690',
        alpha3: 'SYC',
        iso: 'SC',
        name: I18n.getCountry('SC'),
      },
      {
        id: '694',
        alpha3: 'SLE',
        iso: 'SL',
        name: I18n.getCountry('SL'),
      },
      {
        id: '702',
        alpha3: 'SGP',
        iso: 'SG',
        name: I18n.getCountry('SG'),
      },
      {
        id: '703',
        alpha3: 'SVK',
        iso: 'SK',
        name: I18n.getCountry('SK'),
      },
      {
        id: '705',
        alpha3: 'SVN',
        iso: 'SI',
        name: I18n.getCountry('SI'),
      },
      {
        id: '706',
        alpha3: 'SOM',
        iso: 'SO',
        name: I18n.getCountry('SO'),
      },
      {
        id: '729',
        alpha3: 'SDN',
        iso: 'SD',
        name: I18n.getCountry('SD'),
      },
      {
        id: '728',
        alpha3: 'SSD',
        iso: 'SS',
        name: I18n.getCountry('SS'),
      },
      {
        id: '144',
        alpha3: 'LKA',
        iso: 'LK',
        name: I18n.getCountry('LK'),
      },
      {
        id: '752',
        alpha3: 'SWE',
        iso: 'SE',
        name: I18n.getCountry('SE'),
      },
      {
        id: '756',
        alpha3: 'CHE',
        iso: 'CH',
        name: I18n.getCountry('CH'),
      },
      {
        id: '740',
        alpha3: 'SUR',
        iso: 'SR',
        name: I18n.getCountry('SR'),
      },
      {
        id: '744',
        alpha3: 'SJM',
        iso: 'SJ',
        name: I18n.getCountry('SJ'),
      },
      {
        id: '748',
        alpha3: 'SWZ',
        iso: 'SZ',
        name: I18n.getCountry('SZ'),
      },
      {
        id: '760',
        alpha3: 'SYR',
        iso: 'SY',
        name: I18n.getCountry('SY'),
      },
      {
        id: '762',
        alpha3: 'TJK',
        iso: 'TJ',
        name: I18n.getCountry('TJ'),
      },
      {
        id: '158',
        alpha3: 'TWN',
        iso: 'TW',
        name: I18n.getCountry('TW'),
      },
      {
        id: '834',
        alpha3: 'TZA',
        iso: 'TZ',
        name: I18n.getCountry('TZ'),
      },
      {
        id: '148',
        alpha3: 'TCD',
        iso: 'TD',
        name: I18n.getCountry('TD'),
      },
      {
        id: '203',
        alpha3: 'CZE',
        iso: 'CZ',
        name: I18n.getCountry('CZ'),
      },
      {
        id: '260',
        alpha3: 'ATF',
        iso: 'TF',
        name: I18n.getCountry('TF'),
      },
      {
        id: '764',
        alpha3: 'THA',
        iso: 'TH',
        name: I18n.getCountry('TH'),
      },
      {
        id: '626',
        alpha3: 'TLS',
        iso: 'TL',
        name: I18n.getCountry('TL'),
      },
      {
        id: '768',
        alpha3: 'TGO',
        iso: 'TG',
        name: I18n.getCountry('TG'),
      },
      {
        id: '772',
        alpha3: 'TKL',
        iso: 'TK',
        name: I18n.getCountry('TK'),
      },
      {
        id: '776',
        alpha3: 'TON',
        iso: 'TO',
        name: I18n.getCountry('TO'),
      },
      {
        id: '780',
        alpha3: 'TTO',
        iso: 'TT',
        name: I18n.getCountry('TT'),
      },
      {
        id: '788',
        alpha3: 'TUN',
        iso: 'TN',
        name: I18n.getCountry('TN'),
      },
      {
        id: '795',
        alpha3: 'TKM',
        iso: 'TM',
        name: I18n.getCountry('TM'),
      },
      {
        id: '796',
        alpha3: 'TCA',
        iso: 'TC',
        name: I18n.getCountry('TC'),
      },
      {
        id: '792',
        alpha3: 'TUR',
        iso: 'TR',
        name: I18n.getCountry('TR'),
      },
      {
        id: '798',
        alpha3: 'TUV',
        iso: 'TV',
        name: I18n.getCountry('TV'),
      },
      {
        id: '804',
        alpha3: 'UKR',
        iso: 'UA',
        name: I18n.getCountry('UA'),
      },
      {
        id: '858',
        alpha3: 'URY',
        iso: 'UY',
        name: I18n.getCountry('UY'),
      },
      {
        id: '548',
        alpha3: 'VUT',
        iso: 'VU',
        name: I18n.getCountry('VU'),
      },
      {
        id: '862',
        alpha3: 'VEN',
        iso: 'VE',
        name: I18n.getCountry('VE'),
      },
      {
        id: '704',
        alpha3: 'VNM',
        iso: 'VN',
        name: I18n.getCountry('VN'),
      },
      {
        id: '876',
        alpha3: 'WLF',
        iso: 'WF',
        name: I18n.getCountry('WF'),
      },
      {
        id: '887',
        alpha3: 'YEM',
        iso: 'YE',
        name: I18n.getCountry('YE'),
      },
      {
        id: '894',
        alpha3: 'ZMB',
        iso: 'ZM',
        name: I18n.getCountry('ZM'),
      },
      {
        id: '716',
        alpha3: 'ZWE',
        iso: 'ZW',
        name: I18n.getCountry('ZW'),
      }
    ];
  }

  /**
   * Returns a list of countries for the choice picker.
   * Use the name as label and the iso as value.
   * Used by CountryActionChoose
   */
  static getCountriesListForPicker() {
    const countriesList = [];
    _.each(CountriesList.getCountriesList(), (countryInfo) => {
      countriesList.push(
        {
          label: countryInfo.name,
          value: countryInfo.iso
        }
      );
    });

    return countriesList;
  }

  /**
   * Returns the name of the given country code or the country code if the name is not found.
   * @param code the country code to find.
   * @returns {String}
   */
  static getCountryNameByCode(code: string) {
    const foundCountryInfo = _.find(CountriesList.getCountriesList(), (countryInfo): boolean => {
      return countryInfo.iso === code;
    });

    if (!_.isUndefined(foundCountryInfo)) {
      return foundCountryInfo.name;
    }

    return code;
  }

}
